import { ITaxDetails } from './../../../models/registration/taxDetails';
import { Action } from '@ngrx/store';
import { IRegisterUser } from 'src/app/models/registration/register';
import { IRegistration } from 'src/app/models/registration/registration';
import { IInvestorDetails } from 'src/app/models/registration/investorDetails';
import { IPersonalDetails } from 'src/app/models/registration/personalDetails';
import { ISourceOfWealth } from 'src/app/models/registration/sourceOfWealth';
import { Update } from '@ngrx/entity';
import { IRegistrantDetails } from 'src/app/models/registration/registrantDetails';
import { IVerification } from 'src/app/models/registration/verification';
import { IBankDetail } from 'src/app/models/registration/bankDetails';
import { HideLoader, ShowLoader } from 'src/app/shared/decorators/loader';

export const REGISTER_NO_ACTION = '[Registration] No action';
export const REGISTER = '[Registration] Register';
export const REGISTER_SUCCESS = '[Registration] Register Success';
export const REGISTER_FAIL = '[Registration] Register Fail';
export const REGISTER_GET_STATUS = '[Registration] Status';
export const REGISTER_GET_STATUS_FAIL = '[Registration] Status Fail';
export const REGISTER_LOAD_STEPS = '[Registration] Load Steps';
export const REGISTER_LOAD_STEPS_SUCCESS = '[Registration] Load Steps Success';
export const REGISTER_LOAD_STEPS_FAIL = '[Registration] Load Steps Fail';
export const REGISTER_SAVE = '[Registration] Save';
export const REGISTER_SAVE_SUCCESS = '[Registration] Save Success';
export const REGISTER_SAVE_FAIL = '[Registration] Save Fail';
export const REGISTER_UPDATE_STATUS = '[Registration] Update Status';
export const REGISTER_UPDATE_REINVESTMENT_OPTION = '[Register] Update Reinvestment';
export const REGISTER_UPDATE_INVESTOR_DETAILS = '[Register] Update Investor';
export const REGISTER_UPDATE_PERSONAL_DETAILS = '[Register] Update Personal Details';
export const REGISTER_UPDATE_TAX_DETAILS = '[Register] Update Tax Details';
export const REGISTER_UPDATE_SOURCE_WEALTH = '[Register] Update Source of Wealth';
export const REGISTER_VERIFY_MEMBER = '[Register] verify member';
export const REGISTER_VERIFY_MEMBER_SUCCESS = '[Register] verify member success';
export const REGISTER_VERIFY_MEMBER_FAIL = '[Register] verify member fail';
export const REGISTER_UPDATE_VERIFICATION_DETAILS = '[Register] Update Verification Details';
export const REGISTER_UPDATE_BANK_DETAILS = '[Register] Update Bank Details';
export const REGISTER_ADD_REGISTRANT = '[Register] Add Registrant';
export const REGISTER_REDIRECT = '[Register] Redirect';
export const REGISTER_SUCCESS_REDIRECT = '[Register] Success Redirect';
export const REGISTER_SHOW_FAILED_MODAL = '[Register] Show Failed Modal';
export const REGISTER_FINAl_SAVE = '[Register] Final Save';
export const REGISTER_FINAL_SAVE_SUCCESS = '[Registration] Final Save Success';
export const REGISTER_FINAL_SAVE_FAIL = '[Registration] Final Save Fail';

export class RegistrationNoAction implements Action {
    readonly type = REGISTER_NO_ACTION;
}

@ShowLoader()
export class Register implements Action {
    readonly type = REGISTER;
    readonly payload: { newInvestor: IRegisterUser };
    constructor(newInvestor: IRegisterUser) {
        this.payload = { newInvestor };
    }
}

@HideLoader(REGISTER)
export class RegisterSuccess implements Action {
    readonly type = REGISTER_SUCCESS;
}

@HideLoader(REGISTER)
export class RegisterFail implements Action {
    readonly type = REGISTER_FAIL;
    readonly payload: { failtext: string };
    constructor(failtext: string) {
        this.payload = { failtext };
    }
}


export class RegistrationGetStatus implements Action {
    readonly type = REGISTER_GET_STATUS;
}

export class RegistrationGetStatusFail implements Action {
    readonly type = REGISTER_GET_STATUS_FAIL;
    readonly payload: { failtext: string };
    constructor(failtext: string) {
        this.payload = { failtext };
    }
}

@ShowLoader()
export class RegistrationLoadSteps implements Action {
    readonly type = REGISTER_LOAD_STEPS;
}

@HideLoader(REGISTER_LOAD_STEPS)
export class RegistrationLoadStepsSuccess implements Action {
    readonly type = REGISTER_LOAD_STEPS_SUCCESS;
    readonly payload: { registration: IRegistration };
    constructor(registration: IRegistration) {
        this.payload = { registration };
    }
}

@HideLoader(REGISTER_LOAD_STEPS)
export class RegistrationLoadStepsFail implements Action {
    readonly type = REGISTER_LOAD_STEPS_FAIL;
    readonly payload: { failtext: string };
    constructor(failtext: string) {
        this.payload = { failtext };
    }
}

@ShowLoader()
export class RegistrationSave implements Action {
    readonly type = REGISTER_SAVE;
}

@HideLoader(REGISTER_SAVE)
export class RegistrationSaveSuccess implements Action {
    readonly type = REGISTER_SAVE_SUCCESS;
    readonly payload: { registration: IRegistration };
    constructor(registration: IRegistration) {
        this.payload = { registration };
    }
}

@HideLoader(REGISTER_SAVE)
export class RegistrationSaveFail implements Action {
    readonly type = REGISTER_SAVE_FAIL;
    readonly payload: { failtext: string };
    constructor(failtext: string) {
        this.payload = { failtext };
    }
}


@ShowLoader()
export class RegistrationFinalSave implements Action {
    readonly type = REGISTER_FINAl_SAVE;
}

@HideLoader(REGISTER_FINAl_SAVE)
export class RegistrationFinalSaveSuccess implements Action {
    readonly type = REGISTER_FINAL_SAVE_SUCCESS;
    readonly payload: { registration: IRegistration };
    constructor(registration: IRegistration) {
        this.payload = { registration };
    }
}

@HideLoader(REGISTER_FINAl_SAVE)
export class RegistrationFinalSaveFail implements Action {
    readonly type = REGISTER_FINAL_SAVE_FAIL;
    readonly payload: { failtext: string };
    constructor(failtext: string) {
        this.payload = { failtext };
    }
}

export class RegistrationUpdateStatus implements Action {
    readonly type = REGISTER_UPDATE_STATUS;
    readonly payload: { status: number };
    constructor(status: number) {
        this.payload = { status };
    }
}

export class RegistrationUpdateInvestorDetails implements Action {
    readonly type = REGISTER_UPDATE_INVESTOR_DETAILS;
    readonly payload: { details: IInvestorDetails };
    constructor(details: IInvestorDetails) {
        this.payload = { details };
    }
}

export class RegistrationUpdateReinvestmentOption implements Action {
    readonly type = REGISTER_UPDATE_REINVESTMENT_OPTION;
    readonly payload: { option: string };
    constructor(option: string) {
        this.payload = { option };
    }
}

export class RegistrationUpdatePersonalDetails implements Action {
    readonly type = REGISTER_UPDATE_PERSONAL_DETAILS;
    readonly payload: Update<IRegistrantDetails>;
    constructor(details: IPersonalDetails, entityId: number) {
        this.payload = {
            id: entityId,
            changes: { personalDetails: details }
        };
    }
}

export class RegistrationUpdateTaxDetails implements Action {
    readonly type = REGISTER_UPDATE_TAX_DETAILS;
    readonly payload: Update<IRegistrantDetails>;
    constructor(details: ITaxDetails, entityId: number) {
        this.payload = {
            id: entityId,
            changes: { taxDetails: details }
        };
    }
}

export class RegistrationUpdateSourceOfWealth implements Action {
    readonly type = REGISTER_UPDATE_SOURCE_WEALTH;
    readonly payload: Update<IRegistrantDetails>;
    constructor(details: ISourceOfWealth, entityId: number) {
        this.payload = {
            id: entityId,
            changes: { sourceOfWealth: details }
        };
    }
}

@ShowLoader()
export class RegistrationVerifyMember implements Action {
    readonly type = REGISTER_VERIFY_MEMBER;
}

@HideLoader(REGISTER_VERIFY_MEMBER)
export class RegistrationVerifyMemberSuccess implements Action {
    readonly type = REGISTER_VERIFY_MEMBER_SUCCESS;
}

@HideLoader(REGISTER_VERIFY_MEMBER)
export class RegistrationVerifyMemberFail implements Action {
    readonly type = REGISTER_VERIFY_MEMBER_FAIL;
}

export class RegistrationUpdateVerificationDetails implements Action {
    readonly type = REGISTER_UPDATE_VERIFICATION_DETAILS;
    readonly payload: Update<IRegistrantDetails>;
    constructor(details: IVerification, entityId: number) {
        this.payload = {
            id: entityId,
            changes: { verification: details }
        };
    }
}

export class RegistrationUpdateBankDetails implements Action {
    readonly type = REGISTER_UPDATE_BANK_DETAILS;
    readonly payload: { details: IBankDetail };
    constructor(details: IBankDetail) {
        this.payload = { details };
    }
}

export class RegistrationAddRegistrant implements Action {
    readonly type = REGISTER_ADD_REGISTRANT;
    readonly payload: { registrant: IRegistrantDetails };
    constructor(registrant: IRegistrantDetails) {
        this.payload = { registrant };
    }
}

export class RegistrationRedirect implements Action {
    readonly type = REGISTER_REDIRECT;
    readonly payload: { status: number };
    constructor(status: number) {
        this.payload = { status };
    }
}

export class RegistrationSuccessRedirect implements Action {
    readonly type = REGISTER_SUCCESS_REDIRECT;
    readonly payload: { status: number };
    constructor(status: number) {
        this.payload = { status };
    }
}


export class RegistrationShowFailedModal implements Action {
    readonly type = REGISTER_SHOW_FAILED_MODAL;
    readonly payload: { status: number };
    constructor(status: number) {
        this.payload = { status };
    }
}

export type RegistrationActions = RegistrationNoAction | Register | RegisterFail | RegistrationGetStatus | RegistrationGetStatusFail |
    RegistrationLoadSteps | RegistrationLoadStepsSuccess | RegistrationLoadStepsFail |
    RegistrationSave | RegistrationSaveSuccess | RegistrationSaveFail |
    RegistrationUpdateStatus | RegistrationUpdateInvestorDetails | RegistrationUpdateReinvestmentOption |
    RegistrationUpdatePersonalDetails | RegistrationUpdateTaxDetails | RegistrationUpdateSourceOfWealth |
    RegistrationVerifyMember | RegistrationVerifyMemberSuccess | RegistrationVerifyMemberFail |
    RegistrationUpdateVerificationDetails | RegistrationUpdateBankDetails | RegistrationAddRegistrant |
    RegistrationRedirect | RegistrationSuccessRedirect | RegistrationShowFailedModal | RegistrationFinalSave | RegistrationFinalSaveSuccess | RegistrationFinalSaveFail;
